import { useQuery } from "react-query"

import { TagEntity, TagGroupEntity } from "../../types/customTag"

export interface TagsResponse {
  results: TagEntity[]
  count: number
}

export interface TagGroupsResponse {
  results: TagGroupEntity[]
  count: number
}

export function useGetCustomTagsQuery(): {
  tags: TagEntity[]
  tagsLoading: boolean
  refetchTags: () => void
} {
  const { data, isLoading, refetch } = useQuery<TagsResponse, string>(`custom-tagging/tag_declarations/`, {
    staleTime: Infinity,
  })
  const tags = data?.results || []

  return { tags, tagsLoading: isLoading, refetchTags: refetch }
}

export function useGetCustomTagGroupsQuery(): {
  tagGroups: TagGroupEntity[]
  tagGroupsLoading: boolean
  refetchTagGroups: () => void
} {
  const { data, isLoading, refetch } = useQuery<TagGroupsResponse, string>(`custom-tagging/tag_groups/`, {
    staleTime: Infinity,
  })
  const tagGroups = data?.results || []
  return { tagGroups, tagGroupsLoading: isLoading, refetchTagGroups: refetch }
}
